module.exports = __webpack_public_path__ + "img/med0011.3e550341.png";